import styled from '@emotion/styled';

export const SadaServiceForm = styled.div``;
